var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M116.879 84.704h-.199l.01.014L14 225.81V226h205.678v-.055L116.879 84.705z","fill":"#0E3175","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M196.436 136.995h-.126l.007.009-64.763 88.876v.12h129.714v-.035l-64.832-88.97z","fill":"#0E3175","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M141.499 74h-.2l.011.014L38.62 215.105v.191h205.677v-.056L141.499 74z","fill":"#1FDE91","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M221.056 126.291h-.126l.006.008-64.763 88.877v.12h129.714v-.035l-64.831-88.97z","fill":"#1FDE91","key":3})]);
}

Logo.defaultProps = {"width":"300","height":"300","viewBox":"0 0 300 300","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
